import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _ExportPilaDataFiles, _PilaDataForRetroactive, _SocialSecuritySpreadSheet, _SocialSecuritySpreadSheetExp, _SocialSecurityTemplate, _SpreadSheetForRetroactive } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { AccountantYear } from "../../GestionTH/EmployeeContract/ProductionPlan/AccountantYear";
import { MonthEditorbyconst } from "../../../RemoteAbstractAction/editors/MonthEditorbyconst";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { SecuritySpreadSheetProcess } from "./SecuritySpreadSheetProcess/SecuritySpreadSheetProcess";
import useModal, { MODAL_LG, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { SelectSocialSecurityTemplateList } from "./SelectSocialSecurityTemplateList";
import { FileInput } from "../../../theme/Component/FileInput";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { InputDate } from "../../../theme/Input/InputDate";
import { ErrorList } from "../../../theme/Component/ErrorList";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { Alert } from "../../../theme/Component/Alert";
import { SecuritySpreadSheetType } from "./SecuritySpreadSheetType";
import { SocialSecuritySpreadSheetEditor } from "./SocialSecuritySpreadSheetEditor";
import { useQueueProvider } from "../../../theme/Component/ValidationDocumentQueue/QueueProvider";
import { InputMoney } from "../../../theme/Input/InputMoney";
import { PilaDataSheets } from "./PilaDataSheets/PilaDataSheets";
import { PdfDocuments } from "../../../documents/PdfDocuments";

type formProps = {
    IdSocialSecurityTemplate: number;
    Media: string;
    MediaContext: string;
    DeleteAll: boolean;
    AccountantDate: any;
}


export const SocialSecuritySpreadSheet = () => {

    const socialsheet = useDataBean(_SocialSecuritySpreadSheet);
    const sheet = useDataBean(_SocialSecuritySpreadSheetExp);
    const createsheet = useDataBean(_PilaDataForRetroactive);
    const exppila = useDataBean(_ExportPilaDataFiles);
    const sheetretro = useDataBean(_SpreadSheetForRetroactive);
    const single = Singleton.getInstance();
    const { addProcess } = useQueueProvider();
    const [month, setMonth] = useState<any>(null);
    const [regexStr, setregexStr] = useState<any>(null);
    const [year, setYear] = useState<any>(_single.getCurrenYear());
    const [lista, setLista] = useState<any>([]);
    const [formato, setFormato] = useState<any>([]);
    const [formControl, setFormControl] = useState<Partial<formProps>>({});
    const [dosc, setDocs] = useState<any[]>([]);
    const [documents, setDocuments] = useState<any>([]);
    const [msgList, setMsgList] = useState<any>([]);
    const [modalplanilla, setModalplanilla] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalplanillacarga, setModalplanillacarga] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalprocces, setModalprocces] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalexport, setModalexport] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const modalSocialFlle = useModal("", MODAL_LG);
    const modalCreateSpread = useModal("", MODAL_SM);
    const modalDocs = useModal("", MODAL_LG);
    const modalView = useModal("Documento", MODAL_LG);

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        socialsheet.instance.getSocialSecuritySpreadSheetCatalog(year, month, regexStr).then(
            (resp: any) => {
                if (resp) {
                    resp.forEach(element => {
                        const spread = element.DataBeanProperties;
                        spread.DocumnetEntity = spread.IDDocument ? `${spread.Mnemonic} ${spread.Consecutive} ${spread.DocumentDate}` : "N/P"

                    });
                    setLista(resp)
                }
            }
        ).catch(err => { toast.error(err) })

    }

    const create = () => {
        socialsheet.setBean({
            IDEmployee: _single.getAccountID()
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        socialsheet.instance.deleteSocialSecuritySpreadSheet(socialsheet.bean.IDSocialSecuritySpreadSheet).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        socialsheet.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDSocialSecuritySpreadSheet', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Planilla Padre', property: 'IDSocialSecuritySpreadSheetParent', visible: true },
        { title: 'Año', property: 'Year', visible: true },
        { title: 'Mes', property: 'MonthName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Usuario', property: 'EmployeeName', visible: true },
        { title: 'Creado', property: 'Since', visible: true },
        { title: 'Retroactivo', property: 'IsRetroactive', visible: true },
        { title: 'Documento de Ajuste', property: 'DocumnetEntity', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${socialsheet.bean.Name}`, "view": true }) } },
            { titulo: "Ver Documento de Ajuste", icono: "ri-file-list-line", visible: socialsheet.bean.IDDocument, evento: () => { modalView.open(); }, },
            { titulo: 'Procesos de Talento Humano Modificados', icono: 'ri-archive-drawer-fill', visible: single.canDelete(), evento: () => { setModalprocces({ ...modalprocces, "view": true }) } },
            { titulo: 'Definir períodos de planillas cargadas', icono: 'ri-upload-2-line', visible: single.canDelete(), evento: () => { setModalplanillacarga({ ...modalplanillacarga, "view": true }) } },
            { titulo: 'Crear Planilla de Retroactivo', icono: 'ri-archive-drawer-fill', visible: single.canDelete(), evento: () => { setModalplanilla({ ...modalplanilla, "view": true }) } },
            { titulo: 'Exportar Planillas en Formato Estandard (TXT)', icono: 'ri-file-download-line', visible: single.canEdit(), evento: () => { exportPilaDataFiles() } },
            { titulo: 'Exportar Informe de Aportes y Parafiscales', icono: 'ri-download-2-fill', visible: single.canDelete(), evento: () => { exportSocialSecuritySpreadSheet() } },
            { titulo: 'Definir Planilla como Retroactivo', icono: 'ri-swap-fill', visible: single.canDelete(), evento: () => { setSocialSecuritySpreadSheetForRetroactive() } },
            { titulo: 'Agregar Archivo de Planilla', icono: 'ri-folder-add-line', visible: single.canDelete(), evento: () => { setFormControl({}); modalSocialFlle.open("Agregar Archivos de Planilla") } },
            { titulo: 'Generar Documento de Ajuste', icono: 'ri-file-3-line', visible: single.canDelete(), evento: () => { setFormControl({}); modalCreateSpread.open("Generar Documento de Ajuste") } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    const exportSocialSecuritySpreadSheet = () => {

        sheet.instance.exportSocialSecuritySpreadSheet(socialsheet.bean.IDSocialSecuritySpreadSheet).then(
            (resp) => {
                if (resp) {
                    setFormato(resp[0]);
                    setModalexport({ ...modalexport, "view": true })
                    toast.success('Exportado');
                    console.log(resp)
                }
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const importFilesToSocialSecuritySpreadSheet = () => {
        socialsheet.instance.importFilesToSocialSecuritySpreadSheet(socialsheet.bean.IDSocialSecuritySpreadSheet, formControl.IdSocialSecurityTemplate, formControl.Media, formControl.MediaContext, null, formControl.DeleteAll).then(
            (resp) => {
                setFormControl({});
                console.log(resp);
                setDocuments(resp)
                modalSocialFlle.close();
                modalDocs.open("Documentos Generados")
            }
        ).catch(err => { toast.error(err) })
    }

    const createSocialSecuritySpreadSheetAdjustment = () => {
        socialsheet.instance.createSocialSecuritySpreadSheetAdjustment(socialsheet.bean.IDSocialSecuritySpreadSheet, formControl.AccountantDate, _single.getAccountID()).then(
            (resp) => {
                setDocuments(resp.DocumentURL);
                setMsgList(resp.MsgList);
                modalCreateSpread.close()
                modalDocs.open("Documento de Ajustes")

            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const createPilaDataForRetroactive = () => {
        createsheet.instance.createPilaDataForRetroactive(socialsheet.bean.IDSocialSecuritySpreadSheet, createsheet.bean.Percent, createsheet.bean.MinSalaryValue, _single.getAccountID()).then(
            (resp) => {
                console.log(resp)
                getLista()
                setModalplanilla({ ...modalplanilla, "view": false });
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const exportPilaDataFiles = () => {

        exppila.instance.exportPilaDataFiles(socialsheet.bean.IDSocialSecuritySpreadSheet, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    if (resp.length == 1) {
                        addProcess(resp[0].DataBeanProperties.IDProcessQueue)
                    }
                }
            }
        )

    }
    const setSocialSecuritySpreadSheetForRetroactive = () => {

        sheetretro.instance.setSocialSecuritySpreadSheetForRetroactive(socialsheet.bean.IDSocialSecuritySpreadSheet).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp)
                }
            }
        )

    }
    return (
        <BasicPage titulo="Planillas de Seguridad Social">
            <div className="row">
                <div className="col-md-6">
                    <AccountantYear label='Vigencia' idSelector={year} onChange={(e) => { setYear(e) }} />
                </div>
                <div className="col-md-6">
                    <MonthEditorbyconst idSelector={month} onChange={(e) => { setMonth(e) }} />
                </div>
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={socialsheet.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>

                    <Modal modal={modal} updateModal={setModal} eventModal={() => {
                        if (!socialsheet.bean.Year) {
                            toast.error("Año no valido")
                            return;
                        }
                        if (typeof socialsheet.bean.Month !== "number" || Number.isNaN(socialsheet.bean.Month)) {
                            toast.error("Mes no valido");
                            return;
                        }

                        editaItem();
                    }}>
                        <div className="row">
                            <div className="col-md-6">
                                <AccountantYear label='Vigencia' idSelector={socialsheet.bean.Year} onChange={(e) => { socialsheet.setBean({ ...socialsheet.bean, "Year": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <MonthEditorbyconst idSelector={socialsheet.bean.Month} onChange={(e) => { socialsheet.setBean({ ...socialsheet.bean, "Month": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <SecuritySpreadSheetType idSelector={socialsheet.bean.Type} onChange={(e) => { socialsheet.setBean({ ...socialsheet.bean, "Type": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <SocialSecuritySpreadSheetEditor render={socialsheet.bean.ID} idSelector={socialsheet.bean.IDSocialSecuritySpreadSheetParent} onChange={(e) => { socialsheet.setBean({ ...socialsheet.bean, "IDSocialSecuritySpreadSheetParent": e.IDSocialSecuritySpreadSheet, "ID": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <label >Nombre</label>
                                <input type="text" className="form-control" value={socialsheet.bean.Name} onChange={(e) => { socialsheet.setBean({ ...socialsheet.bean, Name: e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalexport} updateModal={setModalexport}>
                        <div className="row">
                            {formato?.DataBeanProperties?.URLLink && (
                                // <PrintJson json={formato.DataBeanProperties.URLLink} />
                                <div className="row">
                                    <div className="col-md-6 mt-3">
                                        <a href={formato.DataBeanProperties.URLLink} target="_blank" rel="noopener noreferrer">
                                            <strong>{formato.DataBeanProperties.Filename}</strong>
                                        </a>
                                    </div>
                                </div>
                            )}

                        </div>
                    </Modal>

                    <Modal modal={modalSocialFlle.modal} updateModal={modalSocialFlle.setModal} eventModal={() => {
                        if (typeof formControl.IdSocialSecurityTemplate !== "number" || Number.isNaN(formControl.IdSocialSecurityTemplate)) {
                            toast.error("Fomato de planilla invalido")
                        } else if (!formControl.Media) {
                            toast.error("Documento invalido")
                        } else {
                            importFilesToSocialSecuritySpreadSheet()
                        }
                    }} >
                        <div className="row">
                            <div className="col-md-6">
                                <SelectSocialSecurityTemplateList label="Formato de Planilla" idSelector={formControl.IdSocialSecurityTemplate} onChange={(e) => { setFormControl({ ...formControl, IdSocialSecurityTemplate: e }) }} />
                            </div>
                            <div className="col-md-6">
                                <FileInput onCreate={(e) => { setFormControl({ ...formControl, Media: e.Media, MediaContext: e.MediaContext }) }} Media={formControl.Media} MediaContext={formControl.MediaContext} ></FileInput>
                            </div>
                            <div className="col-md-6">
                                <label >Eliminar Datos Anteriores</label>
                                <BasicSwitch estado={formControl.DeleteAll ?? false} eventChange={(e) => { setFormControl({ ...formControl, DeleteAll: e }) }} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalCreateSpread.modal} updateModal={modalCreateSpread.setModal} eventModal={() => {
                        if (!formControl.AccountantDate) {
                            toast.error("Fecha no valida");
                        } else {
                            createSocialSecuritySpreadSheetAdjustment()
                        }
                    }} >
                        <div className="row">
                            <div className="col-md-12">
                                <InputDate label="Fecha de registro contable" name="" value={formControl.AccountantDate} setDate={(e) => { setFormControl({ ...formControl, AccountantDate: e }) }} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalDocs.modal} updateModal={modalDocs.setModal}  >
                        {msgList?.length > 0 &&
                            <ErrorList lista={msgList} />

                        }
                        {msgList?.length === 0 && documents.length > 0 ?
                            <DocumentViewer key={documents} list={documents} />
                            :
                            <Alert children={"Sin documentos"} clase="info" />
                        }
                    </Modal>

                    <Modal modal={modalprocces} updateModal={setModalprocces}>
                        <div className="row">
                            <SecuritySpreadSheetProcess idSocialSecurityTemplate={socialsheet.bean.IDSocialSecuritySpreadSheet} />
                        </div>
                    </Modal>

                    <Modal modal={modalView.modal} updateModal={modalView.setModal}>
                        <div className="row">
                            <div className="col-md-12">
                                <PdfDocuments documentLocation={socialsheet.bean.IDDocument} mnemonic={socialsheet.bean.Mnemonic} date={socialsheet.bean.DocumentDate} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalplanillacarga} updateModal={setModalplanillacarga}>
                        <div className="row">
                            <PilaDataSheets idSocialSecuritySpreadSheet={socialsheet.bean.IDSocialSecuritySpreadSheet} />
                        </div>
                    </Modal>
                    <Modal modal={modalplanilla} updateModal={setModalplanilla} eventModal={createPilaDataForRetroactive}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Porcentaje a Incrementar</label>
                                <InputMoney _value={createsheet.bean.Percent} onChange={(e: any) => { createsheet.setBean({ ...createsheet.bean, 'Percent': e }) }} />
                                {/* <input type="text" name="Percent" className="form-control" value={createsheet.bean.Percent} onChange={(e) => { createsheet.setBean({ ...createsheet.bean, "Percent": parseInt(e.target.value) }) }} /> */}
                            </div>
                            <div className="col-md-12">
                                <label>Salario Mínimo</label>
                                <InputMoney _value={createsheet.bean.MinSalaryValue} onChange={(e: any) => { createsheet.setBean({ ...createsheet.bean, 'MinSalaryValue': e }) }} />
                                {/* <input type="text" name="MinSalaryValue" className="form-control" value={createsheet.bean.MinSalaryValue} onChange={(e) => { createsheet.setBean({ ...createsheet.bean, "MinSalaryValue": parseInt(e.target.value) }) }} /> */}
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {socialsheet.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage >
    )
}